import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    'selector': 'app-crmSetup',
    'templateUrl': './crmSetup.page.html',
    'styleUrls': ['./crmSetup.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule]
})
export class CrmSetupPage {

    // constructor() { }

}
